import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { HelpHelpCenterAri } from '@atlassian/ari/help/help-center';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, {
	type HelpCenterManagementSettingsApp_Query,
} from './__generated__/HelpCenterManagementSettingsApp_Query.graphql.ts';

type HelpCenterManagementSettingsAppEntryPointComponent = EntryPointComponent<
	{
		helpCenterManagementSettingsQuery: HelpCenterManagementSettingsApp_Query;
	},
	{},
	{},
	{ activationId: string }
>;

export const helpCenterManagementSettingsAppEntryPoint: EntryPoint<
	HelpCenterManagementSettingsAppEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<HelpCenterManagementSettingsAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-management-settings-app" */ './HelpCenterManagementSettingsApp.tsx',
	),
	getPreloadProps: ({
		context: { match },
		tenantContext: { activationId, cloudId },
	}: EntryPointRouteParams) => {
		const helpCenterId = match.params.helpcenterId;

		if (!helpCenterId) {
			throw new Error('helpcenterId is required');
		}

		return {
			extraProps: {
				activationId,
			},
			queries: {
				helpCenterManagementSettingsQuery: {
					parameters,
					variables: {
						cloudId,
						helpCenterAri: HelpHelpCenterAri.create({
							activationId,
							helpCenterId,
						}).toString(),
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
